var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"component-map-logo"},[_c('div',{staticClass:"logo"},[_c('v-img',{staticClass:"logo-image heartbeat",attrs:{"alt":"Mielopolis","contain":"","src":require("../assets/mielopolis-logo-v3.png")}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }